import InstructorAIPage from './Main';

export type MainType = Record<string, never>;

export default InstructorAIPage;
